// src/app/layouts/shared/menu/menu.ts  (or wherever your menu.ts lives)
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    icon: 'ri-dashboard-line',
    badge: { variant: 'success', text: 'MENUITEMS.DASHBOARDS.BADGE' },
    link: '/'
  },
  { id: 16, label: 'Internal Dashboard', icon: 'ri-dashboard-2-line', link: '/internal-dashboard' },
  { id: 17, label: 'Inventory', icon: 'ri-archive-line', link: '/inventory' },
  { id: 3, label: 'MENUITEMS.BACKOFFICEUSERS.TEXT', icon: 'ri-group-line', link: '/users' },
  { id: 4, label: 'MENUITEMS.SALESREPUSERS.TEXT',  icon: 'ri-group-line', link: '/salesreps' },
  { id: 5, label: 'MENUITEMS.LOCATION.TEXT',        icon: 'ri-map-pin-line', link: '/locations' },
  { id: 7, label: 'MENUITEMS.BOARDS.TEXT',          icon: 'ri-layout-grid-line', link: '/boards' },
  { id: 8, label: 'MENUITEMS.ACTIVATION.TEXT',      icon: 'ri-toggle-line', link: '/activations' },
  { id: 9, label: 'MENUITEMS.BOARDREAD.TEXT',       icon: 'ri-file-text-line', link: '/boardReads' },
  { id: 10, label: 'MENUITEMS.BOARDSTATS.TEXT',     icon: 'ri-bar-chart-line', link: '/boardStats' },
  { id: 12, label: 'MENUITEMS.COLLECTIONSUMMARY.TEXT', icon: 'ri-bar-chart-line', link: '/collectionSummary' },
  { id: 13, label: 'Pending Collections', icon: 'ri-time-line', link: '/pending-collections' },
  { id: 14, label: 'Konnect Live Reads', icon: 'ri-flashlight-line', link: '/fusion-connect' },
  { id: 15, label: 'Konnect Live Stats', icon: 'ri-line-chart-line', link: '/fusion-connect-stats' },
];
